<template>
  <div>
    <b-modal
      id="modal-add-customfields"
      ref="modal-add-customfields"
      cancel-variant="outline-secondary"
      title="Add Custom Field"
      ok-title="Add"
      size="md"
      no-close-on-backdrop
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="loader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <form
          ref="agreementform"
        >
          <validation-observer
            ref="customFieldRules"
            tag="form"
          >
            <b-row
              class="custom-field-form"
            >
              <b-col cols="12">
                <validation-provider
                  #default="{ errors }"
                  name="Custom Field For"
                  rules="required"
                >
                  <b-form-group
                    label="Custom Field For"
                    label-for="custom-field-for"
                  >
                    <b-form-radio-group
                      v-model="customFieldForSelected"
                      :options="customFieldForOptions"
                      class="demo-inline-spacing"
                      name="radio-inline"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider
                  #default="{ errors }"
                  name="Mandatory"
                  rules="required"
                >
                  <b-form-group
                    label="Mandatory"
                    label-for="hi-first-name"
                  >
                    <b-form-radio-group
                      v-model="mandatorySelected"
                      :options="mandatoryOptions"
                      class="demo-inline-spacing"
                      name="mandatory-radio-inline"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                md="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Data Type"
                  rules="required"
                >
                  <b-form-group
                    label="Data Type"
                    label-for="data-type"
                    :state="errors.length > 0 ? false:null"
                  >
                    <v-select
                      ref="sendby"
                      v-model="fieldType"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="fieldTypeOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="fieldType"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Field Name"
                  label-for="interest-free-months"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Field Name"
                    rules="required"
                  >
                    <b-form-input
                      id="interest-free-months"
                      v-model="fieldName"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Field Name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="fieldType === 'select'"
                md="12"
              >
                <b-col cols="12">
                  <validation-provider
                    #default="{ errors }"
                    name="Detail Page Type"
                    rules="required"
                  >
                    <b-form-group
                      label="Option Type"
                      label-for="option_type"
                    >
                      <b-form-radio-group
                        v-model="optionTypeVal"
                        :options="optionsTypeArgs"
                        class="demo-inline-spacing"
                        name="optionTypeVal"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-row
                  v-for="(data, index) in selectOptions"
                  v-show="optionTypeVal === 0"
                  :key="index"
                >
                  <b-form-group
                    v-if="optionTypeVal === 0"
                    :class="index > 0 ? 'col-10 inline-block' : 'col-12'"
                    :label-for="`option_${data.index}`"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="`Option ${data.index}`"
                      rules="required"
                    >
                      <b-form-input
                        :id="`option_${data.index}`"
                        v-model="data.val"
                        :state="errors.length > 0 ? false:null"
                        :placeholder="`Option ${data.index}`"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-show="index > 0"
                    class="col-2 inline-block"
                  >
                    <b-button
                      variant="gradient-danger"
                      class="btn-icon rounded-circle"
                      size="sm"
                      @click="removeButton(index)"
                    >
                      <feather-icon icon="Trash2Icon" />
                    </b-button>
                  </b-form-group>
                </b-row>

                <b-form-group
                  v-show="optionTypeVal === 0"
                  class="text-center"
                >
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon rounded-circle"
                    @click="addOption"
                  >
                    <feather-icon
                      icon="PlusIcon"
                    />
                  </b-button>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-checkbox
                  v-model="process_conditions_module"
                  class="custom-control-primary"
                >
                  {{ 'Show up on the process conditions module' }}
                </b-form-checkbox>
              </b-col>
              <b-col
                md="12"
                class="mt-1"
              >
                <b-form-checkbox
                  v-model="is_communication_module"
                  class="custom-control-primary"
                >
                  {{ "Mappable in the send letter/sms/email process module" }}
                </b-form-checkbox>
              </b-col>
              <b-col
                md="12"
                class="mt-1"
              >
                <b-form-checkbox
                  v-model="display_in_add_edit_page"
                  class="custom-control-primary"
                  :disabled="isDisabled"
                >
                  {{ 'Show up on add/edit form' }}
                </b-form-checkbox>
              </b-col>
              <b-col
                md="12"
                class="mt-1"
              >
                <b-form-checkbox
                  v-model="display_in_detail_page"
                  class="custom-control-primary"
                >
                  {{ 'Show up on detail page' }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </validation-observer>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BOverlay, BFormCheckbox, BFormRadioGroup, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'
// import i18n from '@/libs/i18n'

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    // BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BFormRadioGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    getCustomFields: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      customFieldForOptions: [
        { text: 'Case Details', value: 'case' },
        { text: 'Debtor Details', value: 'debtor' },
        { text: 'Client Details', value: 'client' },
      ],
      mandatoryOptions: [
        { text: 'Yes', value: 1 },
        { text: 'No', value: 0 },
      ],
      fieldTypeOptions: [
        { label: 'String', value: 'string' },
        { label: 'Number', value: 'number' },
        { label: 'Boolean', value: 'boolean' },
        { label: 'Date', value: 'date' },
        { label: 'Time', value: 'time' },
        { label: 'Select', value: 'select' },
        { label: 'Multiline String', value: 'multiline string' },
      ],
      fieldType: '',
      mandatorySelected: '',
      customFieldForSelected: '',
      fieldName: '',
      process_conditions_module: 0,
      is_communication_module: 0,
      display_in_add_edit_page: 0,
      display_in_detail_page: 0,
      loader: false,
      required,
      email,
      selectOptions: [{
        index: 1,
        val: '',
      }],
      optionFields: 1,
      optionsTypeArgs: [
        { text: 'Link to Airports Data', value: 1 },
        { text: 'Custom Options', value: 0 },
      ],
      optionTypeVal: 1,
      isDisabled: false,
    }
  },
  watch: {
    fieldType: {
      deep: true,
      handler(val) {
        if (val !== 'select' && this.optionFields > 1) {
          this.optionFields = 1
          this.selectOptions = [{
            index: 1,
            val: '',
          }]
        }
      },
    },
    mandatorySelected: {
      deep: true,
      handler(val) {
        if (val === 1 || val === true) {
          this.display_in_add_edit_page = true
          this.isDisabled = true
        } else {
          this.display_in_add_edit_page = false
          this.isDisabled = false
        }
      },
    },
  },
  methods: {
    resetModal() {
      this.fieldType = ''
      this.mandatorySelected = ''
      this.customFieldForSelected = ''
      this.fieldName = ''
      this.process_conditions_module = 0
      this.is_communication_module = 0
      this.display_in_add_edit_page = 0
      this.display_in_detail_page = 0
    },
    submitHandler(evt) {
      evt.preventDefault()
      this.$refs.customFieldRules.validate().then(success => {
        if (success) {
          const opts = this.selectOptions.map(e => e.val)
          this.loader = true
          const data = {
            variable: this.fieldName,
            var_type: this.fieldType,
            var_for: this.customFieldForSelected,
            is_required: this.mandatorySelected,
            enable_as_condition: this.process_conditions_module,
            mappable_var: this.is_communication_module,
            display_in_add_edit_page: this.display_in_add_edit_page,
            display_in_detail_page: this.display_in_detail_page,
            airportData: this.optionTypeVal,
          }
          if (this.fieldType === 'select' && this.optionTypeVal === 0) {
            data.options = opts
          }
          axios.post('/settings/add-custom-variables', data).then(response => {
            if (response.status) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'primary',
                  text: 'Custom field has been added.',
                },
              })
            }
            this.loader = false
            this.$refs['modal-add-customfields'].hide()
            this.getCustomFields()
            setTimeout(() => {
              this.resetModal()
            }, 1000)
          }).catch(err => {
            if (err.response.data.message) {
              this.loader = false
              const msg = err.response.data.message
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Warning',
                  icon: 'CoffeeIcon',
                  variant: 'warning',
                  text: msg,
                },
              })
            }
          })
        }
      })
    },
    addOption() {
      this.optionFields += 1
      this.selectOptions.push({
        index: this.optionFields,
        val: '',
      })
      // eslint-disable-next-line no-return-assign, no-multi-assign, no-param-reassign
      this.selectOptions.map((e, i) => e.index = i += 1)
    },
    removeButton(index) {
      this.selectOptions.splice(index, 1)
      // eslint-disable-next-line no-return-assign, no-multi-assign, no-param-reassign
      this.selectOptions.map((e, i) => e.index = i += 1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.optionsClass {
  margin-bottom: 10px;
}

.custom-control.custom-control-inline.custom-radio {
  margin-top: 5px;
}

.demo-inline-spacing .custom-control-label {
  margin-top: 2px;
}

.custom-field-form {
  padding: 5px;
}
</style>
